import {
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
} from "@remix-run/react";
import "./tailwind.css";
import { Toaster } from "@/components/ui/display/toaster.tsx";
import { ReactNode } from "react";
import { LinksFunction } from "@remix-run/node";

import stylesheet from "@/globals.css?url";

export const links: LinksFunction = () => [
	{ rel: "stylesheet", href: stylesheet, as: 'style' },
	// { rel: "manifest", href: '/media/favicon/manifest.json' },
	{ rel: "icon", href: '/media/favicon/favicon-96x96.png', type: 'image/png', sizes: '96x96'  },
	{
		rel: 'preconnect',
		href: 'https://fonts.googleapis.com',
	},
	{
		rel: 'preconnect',
		href: 'https://fonts.gstatic.com',
		crossOrigin: 'anonymous',
	},
	{
		href: 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap',
		rel: 'stylesheet',
	},
];


export function Layout({ children }: { children: ReactNode }) {
	// noinspection HtmlRequiredTitleElement
	return (
		<html lang="en">
		<head>
			<meta charSet="utf-8"/>
			<meta name="viewport" content="width=device-width, initial-scale=1"/>
			<Meta/>
			<Links/>
			<meta name="robots" content="noindex,nofollow"/>
		</head>
		<body>
		{children}
		<ScrollRestoration/>
		<Scripts/>
		<Toaster/>
		</body>
		</html>
	);
}

export default function App() {
	return <Outlet/>;
}
